import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import CrmDrawer from '../components/CrmDrawer';

import Dashboard from '../pages/Dashboard';
import Projects from '../pages/Projects';
import Crm from '../pages/Crm';
import CustomerEdit from '../pages/CustomerEdit';
import Calendar from '../pages/Calendar';
import ConstructionLog from '../pages/ConstructionLog';
import WorkOrders from '../pages/WorkOrders'; 
import ProjectExpenses from '../pages/ProjectExpenses'; // NOVI UVOZ ZA STVARNE TROŠKOVE
import Expenses from '../pages/Expenses'; // ORIGINALNI TROŠKOVNIK
import Activities from '../pages/Activities';

import { useProject } from '../context/ProjectContext';

export default function MainLayout() {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  const { selectedProjectID } = useProject();

  // Listener za zatvaranje CRM ladice ili mobilnog menija na tipku ESC
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' || e.keyCode === 27) {
        if (selectedCustomer) {
          setSelectedCustomer(null);
        } else if (isMobileMenuOpen) {
          setIsMobileMenuOpen(false);
        }
      }
    };

    if (selectedCustomer || isMobileMenuOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedCustomer, isMobileMenuOpen]);

  return (
    <div className="flex bg-[#f7f9fb] text-slate-800 font-sans min-h-screen">
      
      {/* SIDEBAR S MOBILNIM STANJEM */}
      <Sidebar 
        isMobileOpen={isMobileMenuOpen} 
        onClose={() => setIsMobileMenuOpen(false)} 
      />

      <div className="flex-1 md:ml-[260px] flex flex-col min-h-screen">
        
        {/* MOBILNA GORNJA TRAKA S 3 CRTICE (Samo na malim ekranima) */}
        <div className="md:hidden flex items-center justify-between bg-white border-b border-slate-200 px-4 py-3 sticky top-0 z-40">
          <button 
            type="button"
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 rounded-xl text-slate-700 hover:bg-slate-100 transition flex items-center justify-center cursor-pointer"
            aria-label="Otvori izbornik"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>

          <div className="flex items-center gap-2">
            <span className="font-extrabold text-slate-800 text-sm tracking-tight uppercase">DEVELOPER</span>
            <span className="text-[9px] bg-slate-900 text-white font-bold px-1.5 py-0.5 rounded">ERP</span>
          </div>

          <div className="w-8"></div>
        </div>

        {/* DESKTOP / GLAVNI HEADER */}
        <Header />

        {/* GLAVNI SADRŽAJ */}
        <main className="p-4 md:p-8 flex-1">
          <Routes>
            <Route path="/" element={<Dashboard selectedProjectID={selectedProjectID} />} />
            <Route path="/projekti" element={<Projects selectedProjectID={selectedProjectID} />} />
            
            <Route path="/crm" element={<Crm onOpenDrawer={(customer) => setSelectedCustomer(customer)} />} />
            <Route path="/crm/edit/:customerID" element={<CustomerEdit />} />
            
            <Route path="/kalendar" element={<Calendar />} />
            <Route path="/dnevnik" element={<ConstructionLog selectedProjectID={selectedProjectID} />} />
            <Route path="/nalozi" element={<WorkOrders selectedProjectID={selectedProjectID} />} /> 
            
            {/* OBA MODULA ZASEBNO */}
            <Route path="/troskovi" element={<ProjectExpenses selectedProjectID={selectedProjectID} />} />
            <Route path="/costs" element={<Expenses selectedProjectID={selectedProjectID} />} />
            
            <Route path="/aktivnosti" element={<Activities />} />
          </Routes>
        </main>
      </div>

      <CrmDrawer 
        selectedCustomer={selectedCustomer} 
        setSelectedCustomer={setSelectedCustomer} 
      />
    </div>
  );
}